// Icons fork: no analytics. Upstream this POSTed to
// account.basketball-gm.com/log_event.php on new-league / completed-season.
// We don't phone home, so it's a no-op.
export const analyticsEventLocal = async (
	_type: "new_league" | "completed_season",
) => {};
